<template>
    <div class="border-type">
        <div
            v-for="option in options"
            :key="option.type"
            class="border-type__type"
            :class="{ active: selectedType === option.type }"
            @click="selectType(option.type)"
        >
            <div :class="['border-type__type-block', option.styleClass]"></div>
            <span>{{ option.label }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "BuilderBorderTypes",
    props: {
        type: {
            type: String,
            default: "default"
        }
    },
    data() {
        return {
            selectedType: this.type
        }
    },
    watch: {
        // type(newValue) {
        //     this.selectedType = newValue
        //     console.log(this.selectedType)
        // }
    },
    computed: {
        options() {
            return [
                { type: "default", label: this.t("common.border_type_1"), styleClass: "default" },
                { type: "standart", label: this.t("common.border_type_2"), styleClass: "standart" },
                { type: "custom", label: this.t("common.border_type_3"), styleClass: "custom" }
            ]
        }
    },
    methods: {
        selectType(type) {
            this.selectedType = type
            this.$emit("selectType", type)
        }
    }
}
</script>

<style lang="scss" scoped>
.border-type {
    display: flex;
    gap: 8px;
    font-family: Inter, sans-serif;
    font-size: 14px;

    &__type {
        box-shadow: 0px 2px 5px 0px #809ebf40;
        font-size: 12px;
        font-weight: 400;
        line-height: 15.6px;
        text-align: center;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 10px;
        border-radius: 4px;
        cursor: pointer;
        box-sizing: border-box;
        outline: none;
        &:hover {
            background-color: #f2f7ff;
        }
    }
    &__type-block {
        width: 64px;
        height: 20px;
        border: 1px solid #52565c;
        background-color: #f3f3f3;
    }
    &__type-block.standart {
        border-radius: 4px;
    }
    &__type-block.custom {
        border-radius: 0 4px 0 4px;
    }
    &__type.active {
        outline: 1px solid #3965ff;
        background-color: #f2f7ff;
    }
}
</style>
